import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';

import SelectPermissions from './SelectPermissions';

export default function useFilters() {
  return useMemo(() => [
    filter('permissions', 'Permissions')
      .component(({ ...props }) => <SelectPermissions {...props} />),
    filter.boolean('active', 'Active'),
  ], [])
}
